import { useEffect } from "react";

export default function useVersionCheck() {
  useEffect(() => {
    fetch("/version.json?_=" + Date.now())
      .then(res => res.json())
      .then(meta => {
        const currentVersion = localStorage.getItem("app_version");
        if (currentVersion && currentVersion !== meta.version) {
          localStorage.setItem("app_version", meta.version);

          const doReload = () => {
            // Simple reload works correctly because .htaccess sets
            // Cache-Control: no-cache on index.html, so the browser always
            // fetches fresh HTML from the server on every navigation.
            window.location.reload();
          };

          if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistrations().then(registrations => {
              registrations.forEach(r => r.unregister());
            });
          }

          if ("caches" in window) {
            caches.keys()
              .then(names => Promise.all(names.map(name => caches.delete(name))))
              .then(doReload)
              .catch(doReload);
          } else {
            doReload();
          }
        } else {
          localStorage.setItem("app_version", meta.version);
        }
      })
      .catch(() => {
        console.warn("Version check failed");
      });
  }, []);
}
